import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { AbstractDataServiceV2 } from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import { CustomizeHttpUrlGenerator } from 'src/app/store/core/url/customizeHttpUrlGenerator';
import { MedicalToolSetModel } from '../../../api/entity/medicalToolSet.model';
import { MedicalToolSetConverter } from '../../../api/entity/converter/medicalToolSet.converter';

@Injectable({
    providedIn: 'root'
})
export class MedicalToolSetDataService extends AbstractDataServiceV2<MedicalToolSetModel, MedicalToolSetConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: MedicalToolSetConverter) {
        super('MedicalToolSet', http, httpUrlGenerator, logger, config, converter);
    }
}

